import React from "react";
import { TimeArticles_Ar } from "./ConstantsArticles";
function MainCalculatorsList() {
  let calculatorsList = TimeArticles_Ar;
  let calculatorName = "Artikel Waktu & Tanggal";
  return (
    <div>
      <div
        className="bg-success text-white text-center"
        style={{ height: "50px" }}
      >
        <b>{calculatorName}</b>
      </div>
      <div className="border border-light">
        <ul>
          {calculatorsList.map(
            (item, index) =>
              item.showMain && (
                <li key={index}>
                  <a href={item.link} className="item-link">
                    {item.name}
                  </a>
                </li>
              )
          )}
        </ul>
      </div>
    </div>
  );
}
export default MainCalculatorsList;
